import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureFirstTouch } from "@/lib/attribution";

// Capture first-touch attribution once per session, before React renders.
captureFirstTouch();

// Harmless browser warning from dropdowns in dialogs; keep it from triggering the dev error overlay
window.addEventListener("error", (e) => {
  if (e.message?.startsWith("ResizeObserver loop")) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
